import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { FontProvider } from "./contexts/FontContext";
import ErrorBoundary from "./Components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <FontProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FontProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
